import React from 'react'
import {useTranslation} from "react-i18next"
import {useSelector} from "react-redux"
import Peyronie_EN from "./Peyronie_EN";
import Peyronie_RU from "./Peyronie_RU";

const Peyronie = () => {
    const {t} = useTranslation()
    const language = useSelector(state => state.language)

    switch (language) {
        case 'EN':
            return (
                <Peyronie_EN/>
            )
        case 'RU':
            return (
                <Peyronie_EN/>
            )
        case 'BG':
            return (
                <Peyronie_EN/>
            )
        default:
            return (
                <Peyronie_EN/>
            )
    }
}

export default Peyronie



// WEBPACK FOOTER //
// ./src/Components/Peyronie/Peyronie.js